export default "__VITE_ASSET__DDaTy16l__"